import React, { PropsWithChildren } from 'react'
import styled, { css } from 'styled-components'
import { rem } from 'polished'

import { mediaQueryUp } from 'components/utils/breakpoint'
import InlineGroup from '../InlineGroup'

const Root = styled(InlineGroup)<{ left?: boolean}>`
  flex-wrap: wrap;

  ${({ left }) => left && css`
    flex-direction: row-reverse;
  `}

  ${mediaQueryUp.sm} {
    flex-wrap: nowrap;
  }
`

const Main = styled.div`
  flex-grow: 1;
  flex-basis: 100%;
  max-width: 100%;
`

const SideBar = styled.div<{ size?: 'sm'}>`
  flex-basis: 100%;
  margin-top: ${rem(20)};

  ${({ size }) => {
    if (size == 'sm') {
      return `${mediaQueryUp.sm} {
        flex-basis: ${rem(250)};
        min-width: ${rem(250)};
        margin-top: 0;
      }`
    } else {
      return `${mediaQueryUp.md} {
        flex-basis: ${rem(400)};
        min-width: ${rem(400)};
        margin-top: 0;
      }`
    }
  }}
`

interface Props {
  left?: boolean;
  size?: 'sm';
  sideBarContent?: React.ReactNode;
  className?: string;
}

function WithSideBar(props: PropsWithChildren<Props>) {
  const {
    sideBarContent,
    className,
    children,
    size,
    left,
  } = props

  return (
    <Root
      size="md"
      left={left}
      className={className}>
      <Main>
        {children}
      </Main>
      <SideBar size={size}>
        {sideBarContent}
      </SideBar>
    </Root>
  )
}

export default WithSideBar
